import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row, ResponsiveEmbed } from "react-bootstrap";
import { navigate } from "@reach/router";
import videojs from "video.js";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { FaRegTimesCircle } from "react-icons/fa";
import { IconContext } from "react-icons";

import "video.js/dist/video-js.css";
import "./vod.css";

import { CLASS_START_WAIT } from "../constants/vod";

function Vod(props) {
  const videoParams = props.location.state;
  const [waitDuration, setWaitDuration] = useState(videoParams.wait_duration);
  const vodContainer = useRef(null);
  console.log(videoParams);

  function onCloseClick() {
    // TODO: any cleanup functions should be called here if they are not already part of component unmount
    console.log("Close button clicked");
    navigate(-1);
  }

  useEffect(() => {
    const videoJsOptions = {
      autoplay: true,
      fill: true,
      controls: true,
      controlBar: {
        progressControl: false,
        volumePanel: false,
        playToggle: false,
        pictureInPictureToggle: false,
        remainingTimeDisplay: false,
      },

      sources: [
        {
          src: videoParams.url,
          type: "application/x-mpegURL",
        },
      ],
    };

    if (waitDuration === 0) {
      let player = videojs(vodContainer.current, videoJsOptions);

      // https://docs.videojs.com/tutorial-setup.html#player-readiness
      player.ready(function () {
        console.log("Player ready");
        let CloseButton = videojs.getComponent("CloseButton");
        let closeButton = new CloseButton(this);
        closeButton.on("close", onCloseClick);
        this.addChild(closeButton);
        if (videoParams.seek_duration > 0) {
          this.currentTime(videoParams.seek_duration);
        }
      });
    }

    return function cleanup() {
      let player = videojs.getPlayer("vjs-player");
      if (player) {
        player.dispose();
        console.log("Player disposed");
      }
    };
  }, [waitDuration, videoParams]);

  return (
    <>
      {waitDuration > 0 ? (
        <Container fluid>
          <Row className="bg-dark w-90 justify-content-end">
            <Col xs="auto" className="p-2">
              <Button variant="link" onClick={onCloseClick}>
                <IconContext.Provider value={{ size: "2rem", color: "white" }}>
                  <FaRegTimesCircle></FaRegTimesCircle>
                </IconContext.Provider>
              </Button>
            </Col>
          </Row>
          <Row
            className="justify-content-center align-items-center text-light bg-dark w-90"
            style={{ height: "60vh" }}
          >
            <Col xs="auto" className="bg-dark align-self-center">
              <CountdownCircleTimer
                onComplete={() => {
                  setWaitDuration(0);
                }}
                isPlaying
                duration={waitDuration}
                colors={[
                  ["#004777", 0.33],
                  ["#F7B801", 0.33],
                  ["#A30000", 0.33],
                ]}
              >
                {({ remainingTime }) => (
                  <p style={{ fontSize: "3rem" }}> {remainingTime} </p>
                )}
              </CountdownCircleTimer>
            </Col>
          </Row>
          <Row
            className="justify-content-center text-light bg-dark w-90"
            style={{ height: "20vh" }}
          >
            <h4>{CLASS_START_WAIT}</h4>
          </Row>
        </Container>
      ) : (
        <Container fluid>
          <Row className="justify-content-center align-items-center">
            <Col className="bg-dark">
              <ResponsiveEmbed aspectRatio="16by9">
                <div data-vjs-player>
                  <video-js ref={vodContainer} id="vjs-player" />
                </div>
              </ResponsiveEmbed>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}

export default Vod;
